import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { NoAuthGuard } from './shared/guards/no-auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'landing',
    loadChildren: () => import('./modules/landing/landing.module').then((m) => m.LandingModule),
    canActivate: [NoAuthGuard],
  },
  {
    path: 'app',
    loadChildren: () => import('./modules/main/main.module').then((m) => m.MainModule),
    canActivate: [AuthGuard],
  },
  {
    path: '404',
    loadChildren: () => import('./modules/error-404/error-404.module').then((m) => m.Error404Module),
  },
  {
    path: '',
    redirectTo: `app/dashboard`,
    pathMatch: 'full',
  },
  { path: '**', redirectTo: '404' },
];
